if (!customElements.get('popup-whatsapp-toggle')) {
  class PopupWhatsappToggle extends HTMLElement {
    constructor() {
      super();

      this.handleFallbackClick = this.handleFallbackClick.bind(this);
      this.handleBackToWhatsappClick = this.handleBackToWhatsappClick.bind(this);
      this.handlePopupAfterShow = this.handlePopupAfterShow.bind(this);
      this.handlePopupToggle = this.handlePopupToggle.bind(this);
      this.handleSubmitButtonAttributeChange = this.handleSubmitButtonAttributeChange.bind(this);

      this.autoCloseTimeout = null;
      this.toastTimeout = null;
      this.submitButtonObserver = null;
    }

    connectedCallback() {
      this.whatsappContainer = this.querySelector('[data-popup-whatsapp-container]');
      this.emailContainer = this.querySelector('[data-popup-email-container]');
      this.fallbackButton = this.querySelector('[data-popup-fallback]');
      this.backToWhatsappButton = this.querySelector('[data-popup-back-to-whatsapp]');
      this.successToast = this.querySelector('[data-popup-success-toast]');
      this.whatsappSubmitButton = this.querySelector('[data-popup-whatsapp-container] [data-lead-submit]');
      this.whatsappPhoneInput = this.querySelector(
        '[data-popup-whatsapp-container] .whatsapp-subscribe-form__input[name="phone"]'
      );
      this.whatsappFieldWrapper = this.querySelector('[data-popup-whatsapp-container] .whatsapp-subscribe-form__field-wrapper');
      this.popup = this.closest('subscription-popup');
      this.whatsappHeading = this.closest('.subscription-popup__blocks')?.querySelector('[data-popup-heading-whatsapp]');
      this.emailHeading = this.closest('.subscription-popup__blocks')?.querySelector('[data-popup-heading-email]');

      if (!this.whatsappContainer || !this.emailContainer) return;

      this.reset();

      if (this.fallbackButton) {
        this.fallbackButton.addEventListener('click', this.handleFallbackClick);
      }

      if (this.backToWhatsappButton) {
        this.backToWhatsappButton.addEventListener('click', this.handleBackToWhatsappClick);
      }

      if (this.popup) {
        this.popup.addEventListener('drawer:handleAfterShow', this.handlePopupAfterShow);
        this.popup.addEventListener('toggle', this.handlePopupToggle);
      }

      if (this.whatsappSubmitButton) {
        this.submitButtonObserver = new MutationObserver(this.handleSubmitButtonAttributeChange);
        this.submitButtonObserver.observe(this.whatsappSubmitButton, {
          attributes: true,
          attributeFilter: ['data-variant'],
        });
      }
    }

    disconnectedCallback() {
      if (this.fallbackButton) {
        this.fallbackButton.removeEventListener('click', this.handleFallbackClick);
      }

      if (this.backToWhatsappButton) {
        this.backToWhatsappButton.removeEventListener('click', this.handleBackToWhatsappClick);
      }

      if (this.popup) {
        this.popup.removeEventListener('drawer:handleAfterShow', this.handlePopupAfterShow);
        this.popup.removeEventListener('toggle', this.handlePopupToggle);
      }

      if (this.submitButtonObserver) {
        this.submitButtonObserver.disconnect();
        this.submitButtonObserver = null;
      }

      this.clearSuccessTimeouts();
    }

    handleFallbackClick(event) {
      event.preventDefault();
      this.showEmailFallback();
    }

    handleBackToWhatsappClick(event) {
      event.preventDefault();
      this.showWhatsappFallback();
    }

    handlePopupAfterShow() {
      this.reset();
    }

    handlePopupToggle() {
      if (!this.popup) return;

      if (this.popup.hasAttribute('open')) {
        this.reset();
      } else {
        this.clearSuccessTimeouts();
        this.hideSuccessToast();
        this.showWhatsappInputRow();
      }
    }

    showEmailFallback() {
      this.clearSuccessTimeouts();
      this.hideSuccessToast();
      this.showWhatsappInputRow();
      this.setVisibility(this.whatsappContainer, false);
      this.setVisibility(this.emailContainer, true);
      this.toggleHeadings(false);
    }

    showWhatsappFallback() {
      this.setVisibility(this.whatsappContainer, true);
      this.setVisibility(this.emailContainer, false);
      this.toggleHeadings(true);
      this.showWhatsappInputRow();
    }

    reset() {
      this.clearSuccessTimeouts();
      this.hideSuccessToast();
      this.showWhatsappFallback();
    }

    handleSubmitButtonAttributeChange(mutations) {
      if (!this.whatsappSubmitButton) return;

      for (const mutation of mutations) {
        if (mutation.type !== 'attributes' || mutation.attributeName !== 'data-variant') continue;

        if (this.whatsappSubmitButton.dataset.variant === 'success') {
          this.handleWhatsappSuccess();
        }
      }
    }

    handleWhatsappSuccess() {
      this.hideWhatsappInputRow();
      this.showSuccessToast();
      this.clearSuccessTimeouts();

      this.autoCloseTimeout = window.setTimeout(() => {
        this.closePopup();
      }, 5000);

      this.toastTimeout = window.setTimeout(() => {
        this.showWhatsappInputRow();
        this.hideSuccessToast();
      }, 5000);
    }

    closePopup() {
      if (!this.popup || !this.popup.hasAttribute('open')) return;

      if (typeof this.popup.hide === 'function') {
        this.popup.hide();
      } else {
        this.popup.removeAttribute('open');
      }
    }

    showSuccessToast() {
      this.setVisibility(this.successToast, true);
    }

    hideSuccessToast() {
      this.setVisibility(this.successToast, false);
    }

    hideWhatsappInputRow() {
      const phoneFieldElement = this.whatsappPhoneInput || this.whatsappFieldWrapper;
      this.setVisibility(phoneFieldElement, false);
    }

    showWhatsappInputRow() {
      const phoneFieldElement = this.whatsappPhoneInput || this.whatsappFieldWrapper;
      this.setVisibility(phoneFieldElement, true);
    }

    toggleHeadings(isWhatsappState) {
      this.setVisibility(this.whatsappHeading, isWhatsappState);
      this.setVisibility(this.emailHeading, !isWhatsappState);
    }

    clearSuccessTimeouts() {
      if (this.autoCloseTimeout) {
        window.clearTimeout(this.autoCloseTimeout);
        this.autoCloseTimeout = null;
      }

      if (this.toastTimeout) {
        window.clearTimeout(this.toastTimeout);
        this.toastTimeout = null;
      }
    }

    setVisibility(element, isVisible) {
      if (!element) return;

      element.hidden = !isVisible;
      element.classList.toggle('hidden', !isVisible);
    }
  }

  customElements.define('popup-whatsapp-toggle', PopupWhatsappToggle);
}
